import { IThemes } from "@/themes/themeUtils";

import base from "./base";
import dark from "./dark";

export const DEFAULT_THEME = "base";

export const themes: IThemes = {
  base,
  dark,
};
